import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axiosInstance from '../../utils/axiosSetup.js';
import Pagination from '../layouts/pagination.jsx';
import DeleteComponent from '../../action/delete.jsx';
import UpdateStatusComponent from '../../action/updatestatus.jsx';
import AddTaskType from './sections/add.jsx';
import EditTaskType from './sections/edit.jsx';

const TaskTypes = () => {
    const [taskTypes, setTaskTypes] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [TTId, setTTId] = useState(null);
    const [filterText, setFilterText] = useState('');
    const [selStatus, setSelStatus] = useState('');

    const fetchTaskTypes = async (currentPage) => {
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/tasktype?page=${currentPage + 1}`)
            .then(response => {
                setTaskTypes(response.data.data);
                setPageCount(Math.ceil(response.data.meta.pagination.total / response.data.meta.pagination.per_page));
            })
            .catch(error => {
                console.error("Error fetching the task-types!", error);
                setTaskTypes([]);
            });
    };

    useEffect(() => {
        fetchTaskTypes(currentPage);
    }, [currentPage]);
    
    const handlePageClick = (event) => {
        setCurrentPage(event.selected);
    };

    // Search input handler
    const filteredItems = taskTypes.filter((item) => {
        var status = selStatus;
        const matchesName = item.name.toLowerCase().includes(filterText.toLowerCase());
        const matchesStatus = status ? item.status === status : true;
        return matchesName && matchesStatus;
    });

    return (
        <>    
            <div className="content container-fluid">
                <div className="page-header">
                    <div className="row align-items-center">
                        <div className="col">
                            <h3 className="page-title">Task Types</h3>
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/dashboard">Dashboard</Link></li>
                                <li className="breadcrumb-item active">Task Types</li>
                            </ul>
                        </div>
                        <div className="col-auto float-end ms-auto">
                            <Link to="#" className="btn add-btn" data-bs-toggle="modal" data-bs-target="#add_tasktype">
                                <i className="fa-solid fa-plus"></i> Add Task Type</Link>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-4 mb-3">
                        <input className="form-control" type="text" placeholder="Search task type..." aria-label="Search Input"
                            value={filterText} onChange={(event)=>{
                                setFilterText(event.target.value)}} />
                    </div>
                    <div className="col-md-4 mb-3">
                        <select className="form-control" value={selStatus}
                            onChange={(event) => { setSelStatus(event.target.value) }}>
                            <option value="">Select Status</option>
                            <option value="1">Active</option>
                            <option value="0">Inactive</option>
                        </select>
                    </div>
                </div>

                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="table-responsive">
                                    <table className="table table-striped custom-table">
                                        <thead>
                                            <tr>
                                                <th>Task Type Title</th>
                                                <th className="text-end">Status &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                </th>
                                                <th className="text-end">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                filteredItems.length > 0 ? (
                                                    filteredItems.map((tasktype) => (
                                                        <tr key={tasktype.id}>
                                                            <td>{tasktype.name}</td>
                                                            <td className="text-end">
                                                                <UpdateStatusComponent 
                                                                    url = "tasktype/status"
                                                                    id = {tasktype.id}
                                                                    fetchData={fetchTaskTypes} 
                                                                    status={tasktype.status}
                                                                    />                                                                
                                                            </td>
                                                            <td className="text-end">
                                                                <div className="dropdown dropdown-action">
                                                                    <Link to="#" className="action-icon dropdown-toggle"
                                                                        data-bs-toggle="dropdown" aria-expanded="false"
                                                                            onClick={() => setTTId(`${tasktype.id}`)}>
                                                                            <i className="material-icons">more_vert</i></Link>
                                                                    <div className="dropdown-menu dropdown-menu-right">
                                                                        <Link className="dropdown-item" to="#" data-bs-toggle="modal"
                                                                            data-bs-target={`#edit_tasktype_${tasktype.id}`}>
                                                                                <i className="fa-solid fa-pencil m-r-5"></i> Edit</Link>
                                                                            <DeleteComponent 
                                                                                url = "tasktype"
                                                                                id = {tasktype.id}
                                                                                fetchData={fetchTaskTypes} />
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="3">No records found</td>
                                                    </tr>
                                                )                                          
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Pagination pageCount={pageCount} handlePageClick={handlePageClick}/>
            </div>

            <AddTaskType list={fetchTaskTypes}/>
            <EditTaskType list={fetchTaskTypes} TTId={TTId} />
        </>
    );
}

export default TaskTypes